import { createStore, createLogger } from "vuex";
import createPersistedState from "vuex-persistedstate";
import getters from "./getters";
import user from "./modules/user";
import common from "./modules/common";

const persistedState = createPersistedState({
    key: "vuex",
    reducer: (val) => {
        return {
            user: val.user,
        };
    },
    storage: window.localStorage,
});
const store = createStore({
    // modules: {
    //     user,
    //     common,
    // },
    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
        taskId: '', //任务id
        aiData: '', //AI量体数据
    },
    getters,
    plugins: [persistedState, createLogger()],
});

export default store;